/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ kg: NonNullable<unknown> }} Features_More_KgInputs */

const en_features_more_kg = /** @type {(inputs: Features_More_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.kg} kg`)
};

const pl_features_more_kg = /** @type {(inputs: Features_More_KgInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`+${i?.kg} kg`)
};

/**
* | output |
* | --- |
* | "+{kg} kg" |
*
* @param {Features_More_KgInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const features_more_kg = /** @type {((inputs: Features_More_KgInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_More_KgInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_features_more_kg(inputs)
	return en_features_more_kg(inputs)
});